import config from '@/config'
import moment from 'moment'
import MobileDetect from 'mobile-detect'
import api from '@/modules/api'
import 'moment/locale/de'
 // eslint-disable-next-line
import momenttimezone from 'moment-timezone'
import store from '@/store'
// const getIpstackUrl = () => store.getters.domainSettings.IpstackUrl
// const getIpApiUrl = () => store.getters.domainSettings.IpApiUrl
const getExtremelookupUrl = () => store.getters.domainSettings.ExtremelookupUrl
const getFreegeoiplookupUrl = () => store.getters.domainSettings.FreegeoiplookupUrl
const { detect } = require('detect-browser')
export const getDeviceDimensions = () => {
  return {
    height: getDeviceHeight(),
    width: getDeviceWidth()
  }
}

export const getBrowserName = () => {
  const browser = detect()
  return browser && browser.name
}
export const getDeviceHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export const getDeviceWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const Ismobile = () => {
  var md = new MobileDetect(window.navigator.userAgent)
  if (md.phone()) {
    return true
  }
}

export const Islandscape = () => {
  // return false
  var md = new MobileDetect(window.navigator.userAgent)
  if (md.phone()) {
    return true
  } else {
    return false
  }
}

export const fixViewPortMetaTag = () => {
  var md = new MobileDetect(window.navigator.userAgent)
  if (md.phone() || md.tablet()) {
    const oldMeta = document.querySelector('meta[name="viewport"]')
    if (oldMeta) {
      document.head.removeChild(oldMeta)
    }
    const properWidth = 1200
    const deviceWidth = getDeviceWidth()
    const ratio = deviceWidth / properWidth
    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = `width=${properWidth}, initial-scale=${ratio}, minimum-scale=${ratio}, maximum-scale=${ratio}, user-scalable=yes`
    document.head.appendChild(viewportMeta)
  }
}

export const resetViewPortMetaTag = () => {
  var md = new MobileDetect(window.navigator.userAgent)
  if (md.phone() || md.tablet()) {
    const oldMeta = document.querySelector('meta[name="viewport"]')
    if (oldMeta) {
      document.head.removeChild(oldMeta)
    }
    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = 'width=device-width, initial-scale=1.0'
    document.head.appendChild(viewportMeta)
  }
}

export const IsUndefined = (value) => {
  var notDefinedVar
  return (typeof value === typeof notDefinedVar)
}

export const IsValid = (value, withLengthCheck) => {
  var notDefinedVar
  if (IsUndefined(withLengthCheck) || withLengthCheck === null || withLengthCheck === false) {
    return (typeof value !== typeof notDefinedVar && value !== null)
  } else {
    return (typeof value !== typeof notDefinedVar && value !== null && value.length !== 0)
  }
}

export const IsNullOrEmpty = (value) => {
  let flage = false
  if (IsUndefined(value) || value === null || value.trim() === '') {
    flage = true
  }
  return flage
}

export const ConvertToMyZone = (value) => {
  if (IsValid(value, true)) {
    moment.locale('en')
    let dbtimezone = moment.tz(value, 'Europe/Amsterdam')
    let localtimezone = dbtimezone.tz(moment.tz.guess())
    return localtimezone
  } else {
    moment.locale('en')
    let timezone = moment.tz.guess()
    return moment().tz(timezone)
  }
}
export const ConvertToUnixDateTime = (value) => {
  if (IsValid(value, true)) {
    moment.locale('en')
    let dbtimezone = moment.tz(value, 'Europe/Amsterdam')
    return dbtimezone.unix()
  } else {
    moment.locale('en')
    let timezone = moment.tz.guess()
    return moment().tz(timezone).unix()
  }
}
export const timeAgoFromNow = (value) => {
  if (value !== '') {
    let timeago = ConvertToMyZone(value)
    return timeago.fromNow()
  } else {
    return ''
  }
}

export const CurrentDateTime = () => {
  return ConvertToMyZone()
}

export const getBrowserLocale = () => {
  return window.navigator.language || window.navigator.userLanguage
}

export const getBrowserLanguage = () => {
  let browserLanguage = window.navigator.language || window.navigator.userLanguage
  if (browserLanguage.includes('-')) {
    browserLanguage = browserLanguage.split('-')[0]
  }
  return browserLanguage
}

export const getDefaultOrBrowserLanguage = (defaultLang = 'de') => {
  let browserLanguage = getBrowserLanguage()
  let browserLocale = getBrowserLocale()
  if (config.supportedLanguages.includes(browserLanguage)) {
    return {
      language: browserLanguage,
      locale: browserLocale
    }
  }
  return {
    language: defaultLang,
    locale: browserLocale
  }
}

export const GetUserLanguage = () => {
  if (typeof localStorage === 'object') {
    try {
      // Geeting language and localize application on this behalf STARTED
      let lang = localStorage.getItem('lan')
      let userLang = ''
      if (lang === null || lang === 'undefined' || lang === '') {
        userLang = window.navigator.language || window.navigator.userLanguage
        localStorage.setItem('CurrentLocale', userLang)
        if (typeof userLang === 'undefined') {
          userLang = 'de'
        } else {
          userLang = userLang.substr(0, 2)
        }
        localStorage.setItem('lan', userLang)
      } else {
        userLang = lang
      }
      return userLang
    } catch (e) {
      Storage.prototype._setItem = Storage.prototype.setItem
      Storage.prototype.setItem = function () {}
      window.location.href = 'compatibility.html'
      alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.')
    }
  }
}

export const HashCodeFromInt = value => {
  if (IsValid(value) && value.toString().indexOf('#') === -1) {
    value = value.toString(16)
    if (parseInt(value) === 0) {
      return '#000000'
    }
    while (value.toString().trim().length < 6) {
      value = '0' + value
    }
    value = '#' + value
  }
  return value
}

export const HexCodeFromColor = value => {
  if (value && value.toString().indexOf('#') !== -1) {
    return parseInt((value).split('#')[1], 16)
  }
  return value
}

export const hexToRgb = hex => {
  hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16)).join(',')
}
export const getExtension = name => {
  let extension = /(?:\.([^.]+))?$/.exec(name)[1]
  if (extension === 'jpg') {
    extension = 'jpeg'
  }
  return extension
}

export const pad = (num, size) => {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const GetParameterValues = (param) => {
  let urldata = decodeURIComponent(window.location.href)
  let url = urldata.slice(urldata.indexOf('?') + 1).split('&')
  for (let i = 0; i < url.length; i++) {
    let urlparam = url[i].split('=')
    if (urlparam[0] === param) {
      return urlparam[1]
    }
  }
}

export const GetChartMonthArray = (minDateDb, locale) => {
  let monthArray = []
  let monthDateArray = []
  const localeData = moment.localeData(locale)
  const todayDate = moment()
  // todayDate.add(1, 'month')
  if (minDateDb) {
    let minDate = moment(minDateDb)
    let minYear = minDate.year()
    do {
      monthArray.push(`${localeData.months(minDate)} ${minYear}`)
      monthDateArray.push(minDate.format('YYYYMMDD'))
      minDate.add(1, 'month')
      minYear = minDate.year()
    }
    while (todayDate.isAfter(minDate))
  }
  return { monthArray: monthArray, monthDateArray: monthDateArray }
}

export const GetChartWeekArray = (minDateDb, locale) => {
  let weekArray = []
  let weekDateBounryArray = []
  if (minDateDb) {
    let minDate = moment(minDateDb)
    const todayDate = moment() // .add(1, 'week')
    do {
    // if (minDate.isoWeek() !== todayDate.isoWeek()) {
      weekArray.push('KW' + (minDate.isoWeek()))
      weekDateBounryArray.push({ 'StartDate': minDate.startOf('isoweek').format('YYYYMMDD'),
        'EndDate': minDate.endOf('isoweek').format('YYYYMMDD')
      })
      minDate.add(1, 'week')
    // }
    }
    while (todayDate.isAfter(minDate))
    weekArray.push('KW' + (todayDate.isoWeek()))
    weekDateBounryArray.push({ 'StartDate': todayDate.startOf('isoweek').format('YYYYMMDD'),
      'EndDate': todayDate.endOf('isoweek').format('YYYYMMDD')
    })
  }
  return { weekArray: weekArray, weekDateBounryArray: weekDateBounryArray }
}

export const GetChartDateArray = (minDateDb, locale) => {
  let monthArray = []
  let monthDayArray = []
  moment.localeData(locale)
  const todayDate = moment()
  // let endDate = moment(todayDate).endOf('month').format('DD.MM.YYYY')
  // let startweekdate = moment().startOf('isoWeek').format('DD.MM.YYYY')
  // let endweekdate = moment().endOf('isoWeek').format('DD.MM.YYYY')
  if (minDateDb) {
    let minDate = moment(minDateDb)
    do {
      if (!todayDate.isSame(minDate)) {
        monthArray.push(minDate.format('dddd, DD.MM.YYYY'))
        monthDayArray.push(minDate.format('YYYYMMDD'))
      }
      minDate.add(1, 'day')
    }
    while (todayDate.isAfter(minDate))
  }
  return { monthArray: monthArray, monthDayArray: monthDayArray }
}

export const getMaxNumber = (items, key) => {
  items.sort((a, b) => {
    return a[key] - b[key]
  })
  let item = items[items.length - 1]
  return item ? item[key] + 1 : 1
}

export const createStyleTag = (id, cssText, context) => {
  context = context || document.head || document.getElementsByTagName('head')[0]
  removeStyleTag(id, context)
  let style = document.createElement('style')
  style.type = 'text/css'
  style.id = id
  if (style.styleSheet) {
    style.styleSheet.cssText = cssText
  } else {
    style.appendChild(document.createTextNode(cssText))
  }
  context.appendChild(style)
}
export const removeStyleTag = (id, context) => {
  let oldStyle = document.getElementById(id)
  if (oldStyle) {
    context = context || document.head || document.getElementsByTagName('head')[0]
    context.removeChild(oldStyle)
  }
}
export const validateEmail = (email) => {
  // eslint-disable-next-line
  let reg = /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}
export const validatePhone = (phone) => {
  // eslint-disable-next-line
  let reg = /^$|^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){3,24}$/
  return reg.test(phone)
}
export const wrapWithQuestionIcon = (message) => {
  return `<div class="el-message-box__status el-icon-question el-icon-warning"></div>
          <div class="el-message-box__message">${message}</div>`
}
export const CheckDateIsFutureDate = (eventObject) => {
  let sdate = (eventObject.EventStartDate)
  let edate = (eventObject.EventEndDate)
  let stime = (eventObject.EventStartTime)
  let etime = (eventObject.EventEndTime)
  let flage = false
  // eslint-disable-next-line
  let tag = null
  let filteredEvent = false
  let currentDateTime = moment()
  switch (true) {
    case IsValid(sdate, true) && IsValid(edate, true) && !IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isSameOrBefore(moment(sdate), 'day') || currentDateTime.isBefore(moment(edate).endOf('day'), 'minute', '[]')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(edate, true) && IsValid(etime, true) :
      tag = FilterEventStartEndDate(sdate, stime, etime)
      filteredEvent = true
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(edate, true) && !IsValid(etime, true) :
      flage = currentDateTime.isSameOrBefore(moment(`${sdate.substring(0, 10)}T${stime}`), 'minute')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    case IsValid(sdate, true) && !IsValid(stime, true) && !IsValid(etime, true) && !IsValid(edate, true):
      flage = currentDateTime.isSameOrBefore(moment(sdate).endOf('day'), 'minute', '[]')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    default:
      flage = false
      tag = 'Past'
  }
  if (tag !== 'Past' && !filteredEvent) {
    return CheckDateIsCurrentDate(eventObject)
  }
  eventObject.eventTag = tag
  return eventObject
}
export const FilterEventStartEndDate = (sdate, stime, etime) => {
  let currentDateTime = moment()
  // eslint-disable-next-line
  let tag = null
  // for same date
  let samedayDate = currentDateTime.isSame(moment(sdate), 'day')
  if (samedayDate) {
    let CurrentdayDate = currentDateTime.isBetween(moment(`${sdate.substring(0, 10)}T${stime}`), moment(`${sdate.substring(0, 10)}T${etime}`), 'minute', '[]')
    if (CurrentdayDate) {
      tag = 'Current'
      return tag
    }
    let sameDtFuturePast = currentDateTime.isAfter(moment(`${sdate.substring(0, 10)}T${stime}`), 'minute') && currentDateTime.isAfter(moment(`${sdate.substring(0, 10)}T${etime}`), 'minute')
    tag = sameDtFuturePast ? 'Past' : 'Future'
    return tag
  } else {
    let dateFuturePast = currentDateTime.isAfter(moment(sdate), 'day')
    tag = dateFuturePast ? tag = 'Past' : 'Future'
    return tag
  }
}
export const CheckDateIsCurrentDate = (eventObject) => {
  let sdate = (eventObject.EventStartDate)
  let edate = (eventObject.EventEndDate)
  let stime = (eventObject.EventStartTime)
  let etime = (eventObject.EventEndTime)
  let flage = false
  // eslint-disable-next-line
  let tag = null
  let currentDateTime = moment()
  switch (true) {
    case IsValid(sdate, true) && IsValid(edate, true) && !IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isBetween(moment(sdate), moment(edate), 'day', '[]')
      tag = flage ? 'Current' : 'Future'
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isBetween(moment(`${sdate.substring(0, 10)}T${stime}`), moment().endOf('day'), 'minute', '[]')
      tag = flage ? 'Current' : 'Future'
      break
    case IsValid(sdate, true) && !IsValid(stime, true) && !IsValid(etime, true) && !IsValid(edate, true):
      flage = currentDateTime.isSame(moment(sdate), 'day')
      tag = flage ? 'Current' : 'Future'
      break
    default:
      flage = false
      tag = 'dcurrent'
  }
  eventObject.eventTag = tag
  return eventObject
}
export const getRandomInt = () => {
  let min = Math.ceil(1)
  let max = Math.floor(1000)
  return Math.floor(Math.random() * (max - min)) + min // The maximum is exclusive and the minimum is inclusive
}

export const removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
  })
}
export const FormattedDateDDMMMMYY = (value) => {
  return FormatDate(value, 'DD MMMM YYYY')
}
export const FormattedDateDDMMMMYYHHMM = (value) => {
  return FormatDate(value, 'DD MMMM YYYY HH:mm')
}
export const language = {
  get () {
    return window.localStorage.getItem('language')
  },
  set (language) {
    window.localStorage.setItem('language', language)
  }
}
export const FormatDate = (value, formatString) => {
  let timezone = ConvertToMyZone(value)
  let ger = language.get() === 'de'
  switch (formatString) {
    case 'DD MMMM YYYY':
      return ger ? timezone.format('DD. MMMM YYYY') : timezone.format('DD MMMM YYYY')
    case 'DD MMM YYYY':
      return ger ? timezone.format('DD. MMM YYYY') : timezone.format('DD MMM YYYY')
    case 'DD MMM':
      return ger ? timezone.format('DD. MMM') : timezone.format('DD MMM')
    case 'DD':
      return timezone.format('DD')
    case 'MMMM':
      return timezone.format('MMMM')
    case 'MMM':
      return timezone.format('MMM')
    case 'YYYY':
      return timezone.format('YYYY')
    case 'DD MMMM YYYY HH:mm':
      return ger ? timezone.format('DD. MMMM YYYY HH:mm') + this.resource.str_uhr : timezone.format('DD MMMM YYYY HH:mm')
    default:
      return ger ? timezone.format('DD[.] MMMM YYYY') : timezone.format('DD MMMM YYYY')
  }
}

export const GetDeviceCountry = async() => {
  let IpObj = ''
  let countryObj = {
    ip: '',
    country_code: '',
    country: '',
    region: '',
    city: '',
    latitude: '',
    longitude: ''
  }
  await api.system.GetIpInfo().then(response => {
    IpObj = response
  })
  let response = null
  // response = await api.system.Get(`${getIpstackUrl() + IpObj}?access_key=6cce930b2c2a298c4ce5aa72b749e038`).then(response => response)
  // if (IsValid(response, true) && response.success !== false && IsValid(response.country_name, true) && IsValid(response.region_name, true) && IsValid(response.city, true)) {
  //   countryObj = {
  //     ip: IpObj,
  //     country_code: response.country_code,
  //     country: response.country_name,
  //     region: response.region_name,
  //     city: response.city,
  //     latitude: parseFloat(response.latitude),
  //     longitude: parseFloat(response.longitude)
  //   }
  // } else {
  //   response = await api.system.Get(getIpApiUrl() + IpObj).then(response => response)
  //   if (IsValid(response, true) && response.status !== 'fail' && IsValid(response.country, true) && IsValid(response.regionName, true) && IsValid(response.city, true)) {
  //     countryObj = {
  //       ip: IpObj,
  //       country_code: response.countryCode,
  //       country: response.country,
  //       region: response.regionName,
  //       city: response.city,
  //       latitude: parseFloat(response.lat),
  //       longitude: parseFloat(response.lon)
  //     }
  //   } else {
  response = await api.system.Get(getExtremelookupUrl() + IpObj).then(response => response)
  if (IsValid(response, true) && response.status !== 'fail' && IsValid(response.country, true) && IsValid(response.region, true) && IsValid(response.city, true)) {
    countryObj = {
      ip: IpObj,
      country_code: response.countryCode,
      country: response.country,
      region: response.region,
      city: response.city,
      latitude: parseFloat(response.lat),
      longitude: parseFloat(response.lon)
    }
  } else {
    response = await api.system.Get(getFreegeoiplookupUrl() + IpObj).then(response => response)
    if (IsValid(response, true) && IsValid(response.country_name, true) && IsValid(response.region_name, true) && IsValid(response.city, true)) {
      countryObj = {
        ip: IpObj,
        country_code: response.country_code,
        country: response.country_name,
        region: response.region_name,
        city: response.city,
        latitude: parseFloat(response.latitude),
        longitude: parseFloat(response.longitude)
      }
    } else {
      countryObj = {
        ip: IpObj,
        country_code: 'N/A',
        country: 'N/A',
        region: 'N/A',
        city: 'N/A',
        latitude: parseFloat('0.000000'),
        longitude: parseFloat('0.000000')
      }
    }
  }

  // let response = await Get(ConstPaths.ExtremelookupUrl + IpObj).then(response => response)
  // if (IsValid(response, true)) {
  //   countryObj= {
  //     ip: response.query,
  //     country_code: response.countryCode,
  //     country:response.country,
  //     region: response.region,
  //     city: response.city,
  //     latitude: parseFloat(response.lat),
  //     longitude: parseFloat(response.lon)
  //   }
  // } else {
  //   response = await Get(ConstPaths.FreegeoiplookupUrl + IpObj).then(response => response)
  //   if (IsValid(response, true)) {
  //      countryObj= {
  //        ip: response.ip,
  //        country_code: response.country_code,
  //        country:response.country_name,
  //        region: response.region_name,
  //        city: response.city,
  //        latitude: parseFloat(response.latitude),
  //        longitude: parseFloat(response.longitude)
  //      }
  //    }
  // }
  return countryObj
}
export const IsNotEqual = (value1, value2) => {
  return (value1 !== value2)
}
export const getFeedbackTime = (InputDate, res) => {
  let { language } = getDefaultOrBrowserLanguage('de')
  // let timezonedate = ConvertToMyZone(InputDate)
  let utcd = moment.utc(InputDate).format('YYYY-MM-DD HH:mm:ss')
  /* eslint-disable*/
  console.log('UTCD', utcd);
  let localTime = moment.utc(utcd).toDate()
  /* eslint-disable*/
  console.log('Local TIme', localTime);
  let tzDate = moment(localTime)
  tzDate.locale(language)
  let timestr = language === 'en' ? ' ' + tzDate.format('a') : res.str_uhr
  /* eslint-disable*/
  console.log('Time Zone', timestr);
  console.log('Time Getting',tzDate.fromNow());
  if (tzDate.format('YYYY-MM-DD') < moment().add(-1, 'days').format('YYYY-MM-DD')) {
    if (language === 'en') {
      return tzDate.format('dddd, DD-MM-YYYY') + ' | ' + tzDate.format('HH:mm') + timestr
    } else {
      return tzDate.format('dddd, DD.MM.YYYY') + ' | ' + tzDate.format('HH:mm') + timestr
    }
  }
  if (tzDate.format('YYYY-MM-DD') === moment().add(-1, 'days').format('YYYY-MM-DD')) {
    return res.str_Feedback_Yesterday + ' | ' + tzDate.format('HH:mm') + timestr
  }
  if (tzDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
    return tzDate.fromNow()
  }
}
export const Validatebeforesave = (Content, notify) => {
  let isvalid = Content.find(data => {
    if (data.properties && !data.properties.isValid && data.properties.isValid === false) {
      return data
    }
  })
  if (isvalid) {
    notify.error({
      ...config.notificationDefaultOptions,
      title: `Validation Error in ${isvalid.properties.actionType}`,
      message: `Please enter the valid ${isvalid.properties.actionType}`
    })
    return false
  }
  return true
}
export const ValidateEmailbeforesave = (Content, notify) => {
  if (Content.Status) {
    if (!Content.isValid) {
      notify.error({
        ...config.notificationDefaultOptions,
        title: `Validation Error in Email`,
        message: `Please enter the valid Email`
      })
      return false
    }
  }
  return true
}
export const getFeedbackFormData = (elementsData, resource, type) => {
  if (elementsData.length > 0) {
    let tableData = []
    elementsData.forEach(val => {
      let tbl = {}
      tbl.label = val.properties.label
      if (val.properties.value) {
        tbl.type = val.elementType
        let { language } = getDefaultOrBrowserLanguage('de')
        let timestr = language === 'en' ? ' ' : resource.str_uhr
        if (val.elementType === 'time-input') {
          tbl.value = val.properties.value ? val.properties.value + timestr : ''
        } else if (val.elementType === 'date-input' || val.elementType === 'calendar') {
          if (language === 'en') {
            tbl.value = val.properties.value ? moment(val.properties.value).format('YYYY-MM-DD') : ''
          } else {
            tbl.value = val.properties.value ? moment(val.properties.value).format('MM.DD.YYYY') : ''
          }
        } else {
          tbl.value = val.properties.value + ' '
        }
      } else {
        tbl.type = val.elementType
        if (val.properties.options && val.properties.options.length === 1) {
          let opt = ''
          if (val.elementType === 'switch-group') {
            opt = val.properties.options[0].value ? val.properties.options[0].text : ''
            tbl.value = opt
          } else {
            opt = val.properties.options[0].value
            tbl.value = JSON.stringify(opt)
          }
        } else if (val.elementType === 'radio-group') {
          let opt = val.properties.options.filter(o => o.default)
          tbl.value = opt.length > 0 ? opt[0].text : ''
        }
      }
      if (type === 'formNews') {
        if (tableData.length < 4) {
          tableData.push(tbl)
        }
      } else {
        tableData.push(tbl)
      }
    })
    return tableData
  }
}
export const convertToBase64 = (selectedFile) => {
  console.log('convert 64')
  var reader = new FileReader()
  reader.readAsDataURL(selectedFile)
  reader.onload = function () {
    console.log(reader.result)
  }
  reader.onerror = function (error) {
    console.log('Error: ', error)
  }
  // var selectedFile = document.getElementById("inputFile").files;
  // Check File is not Empty
  if (selectedFile.length > 0) {
      // Select the very first file from list
    var fileToLoad = selectedFile[0]
      // FileReader function for read the file.
    var fileReader = new FileReader()
    var base64
      // Onload of file read the file content
    fileReader.onload = function (fileLoadedEvent) {
      base64 = fileLoadedEvent.target.result
        // Print data in console
      console.log(base64)
    }
      // Convert data to base64
    fileReader.readAsDataURL(fileToLoad)
  }
}
export const getBase64FromImage = (mediaUrl, thisVal, onSuccess, onError) => {
  var xhr = new XMLHttpRequest()
  let that = thisVal
  that.attachdisable = true
  xhr.responseType = 'arraybuffer'
  xhr.open('GET', mediaUrl, true)
  xhr.onload = function () {
    var base64, binary, bytes, mediaType
    bytes = new Uint8Array(xhr.response)
    // NOTE String.fromCharCode.apply(String, ...
    // may cause "Maximum call stack size exceeded"
    binary = [].map.call(bytes, function (byte) {
      return String.fromCharCode(byte)
    }).join('')
    mediaType = mediaUrl.substring(mediaUrl.lastIndexOf('.') + 1, mediaUrl.length) || ''
    let b2a = btoa(binary)
    base64 = [
      'data:image/',
      mediaType ? mediaType + ';' : '',
      'base64,',
      b2a
    ].join('')
    onSuccess(base64, b2a)
  }
}



// WEBPACK FOOTER //
// ./src/modules/helper/index.js